import { render } from "./App.vue?vue&type=template&id=b98e5b7e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b98e5b7e&lang=scss"

import exportComponent from "D:\\git_codes\\wokespac\\isw-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__